import { Component, inject, Signal } from '@angular/core';
import { LundifySubscriptionFacade } from '../services/lundify-subscription.facade';
import { TranslatableComponent } from 'src/app/core/i18n/TranslatableComponent';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-lundify-bundle',
  templateUrl: './lundify-bundle.component.html',
  providers: [getTranslationProvider('LundifyBundleComponent')],
})
export class LundifyBundleComponent extends TranslatableComponent {
  private lundifySubscriptionFacade = inject(LundifySubscriptionFacade);

  get bundleName(): Signal<string> {
    return this.lundifySubscriptionFacade.bundleName;
  }

  get isLoading(): Signal<boolean> {
    return this.lundifySubscriptionFacade.isLoading;
  }

  openClientInLundify(): void {
    const publicKey = this.lundifySubscriptionFacade.publicKey();
    const lundifyUrl = `${environment.blappWeb}/${publicKey || ''}?lang=${this.getActiveLanguage()}`;
    window.open(lundifyUrl, '_blank');
  }
}
